<script setup lang="ts">
import VIconButton from '@components/buttons/VIconButton/VIconButton.vue';
import VFormCheckbox from '@modules/forms/components/inputs/VFormCheckbox/VFormCheckbox.vue';
import { QA_TABLES } from '@modules/tables/constants';

import type { ITableMobilePreviewColumnsEmits, ITableMobilePreviewColumnsProps } from './types';
import VTableMobileMenu from '../VTableMobileMenu/VTableMobileMenu.vue';

const props = defineProps<ITableMobilePreviewColumnsProps>();
const emit = defineEmits<ITableMobilePreviewColumnsEmits>();

function isActive(columnName: string): boolean {
  return props.previewColumns.includes(columnName);
}

function onChange(columnName: string, active?: boolean): void {
  emit('update', columnName, !!active);
}
</script>

<template>
  <VTableMobileMenu v-data-qa-auto-id="'VTableMobilePreviewColumns'" :columns="columns">
    <template #default="{ openMenu }">
      <VIconButton
        v-data-test="{ el: QA_TABLES.mobilePreviewMenu }"
        icon="pi pi-list"
        class="text-muted-color"
        @click="openMenu($event)"
      />
    </template>
    <template #item="{ column }">
      <div
        v-data-test="{ el: QA_TABLES.mobilePreviewMenuItem }"
        class="flex min-h-[42px] cursor-pointer items-center justify-between px-4 py-2 hover:bg-gray-100"
      >
        <VFormCheckbox
          :label="String(column.label)"
          :value="isActive(column.name)"
          is-full-width
          @change="(value) => onChange(column.name, value)"
        />
      </div>
    </template>
  </VTableMobileMenu>
</template>
